export default {
  partNoPlaceholder: 'Select a part number',
};
